import {pageInfo, initPage, orderDetail, getExportData, deleteData, orderClose, orderCopy, orderPdfDownload, repeatPushSap, initSpecialAddressData, addSpecialAddressSubmit} from './../api';
import { orderStatus, orderStatusList } from '../../../../api';
import { Message } from 'element-ui';
const search = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    initPageObj: null,
    orderDetailObj: null,
    exportObj: null,
    orderStatusObj: null,
    deleteResp: null,
    orderCloseResp: null,
    orderStatusListData: null,
    orderCopyData: null,
    orderPdfDownloadData: null,
    repeatPushSapData: null,
    specialAddressObj: null,
    specialAddressSubmitObj: null,
  },
  //item.pdfDownloadFlag == '10'
  mutations: {

    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, item.copyFlag == '10', item.pdfDownloadFlag == '10', item.repeatPushSapFlag == '10', item.spacilAddrFlag == '10' ] }));
    },
    INIT_PAGE(state, data) {
      state.initPageObj = data.obj || {};
    },
    ORDER_DETAIL(state, data) {
      state.orderDetailObj = data.obj || {};
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    ORDERSTATUS_DATA(state, data) {
      state.orderStatusObj = data.obj || {};
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    ORDER_CLOSE(state,data){
      state.orderCloseResp = data;
    },
    ORDER_STATUS_LIST(state,data){
      state.orderStatusListData = data.obj || [];
    },
    ORDER_COPY_DATA(state,data){
      state.orderCopyData = data;
    },
    ORDERPDF_DOWNLOAD_DATA(state,data){
      state.orderPdfDownloadData = data;
    },
    REPEAT_PUSH_SAP_DATA(state,data){
      state.repeatPushSapData = data;
    },
    /**
     * 特殊地址初始化
     * @param state
     * @param data
     * @constructor
     */
    INIT_SPECIAL_ADDRESS_DATA(state,data){
      state.specialAddressObj = data;
    },
    /**
     * 新增特殊地址提交
     * @param state
     * @param data
     * @constructor
     */
    ADD_SPECIAL_ADDRESS_SUBMIT(state,data){
      state.specialAddressSubmitObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async orderDetail({commit}, obj){
      let resp = await orderDetail(obj);
      commit('ORDER_DETAIL', resp);
    },
    //初始化更新对象事件
    async getExportData({commit}, obj){
      let resp = await getExportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //订单状态
    async orderStatus({commit}, obj){
      let resp = await orderStatus(obj);
      commit('ORDERSTATUS_DATA', resp);
    },
    //删除
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //查询运单数据
    async orderClose({commit}, obj){
      let resp = await orderClose(obj);
      commit('ORDER_CLOSE', resp);
    },
    async orderStatusList({commit}, obj){
      let resp = await orderStatusList(obj);
      commit('ORDER_STATUS_LIST', resp);
    },
    async orderCopy({commit}, obj){
      let resp = await orderCopy(obj);
      commit('ORDER_COPY_DATA', resp);
    },
    async orderPdfDownload({commit}, obj){
      let resp = await orderPdfDownload(obj);
      commit('ORDERPDF_DOWNLOAD_DATA', resp);
    },
    async repeatPushSap({commit}, obj){
      let resp = await repeatPushSap(obj);
      commit('REPEAT_PUSH_SAP_DATA', resp);
    },
    /**
     * 特殊地址初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async initSpecialAddressData({commit}, obj){
      let resp = await initSpecialAddressData(obj);
      commit('INIT_SPECIAL_ADDRESS_DATA', resp);
    },
    /**
     * 特殊地址提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async addSpecialAddressSubmit({commit}, obj){
      let resp = await addSpecialAddressSubmit(obj);
      commit('ADD_SPECIAL_ADDRESS_SUBMIT', resp);
    },
  }
  }
export default search



// WEBPACK FOOTER //
// ./src/page/order/search/store/search.store.js